import { getRankMethodInfo, RankMethod, RankMethodInfo } from '@models/analysis/RankMethod';

export const useRankMethodInfo = (rank_method: RankMethod): { rankMethodInfo: RankMethodInfo } => {
    const info = getRankMethodInfo(rank_method);
    return { rankMethodInfo: info };
};
